import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";

@Component({
	selector: "app-release-notes",
	templateUrl: "./release-notes.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class ReleaseNotesComponent implements OnInit {
	@Input() releaseNoteArticleUrl: string;
	@Output() releaseNoteArticleUrlChange = new EventEmitter<string>();

	@Input() hideReleaseNote: boolean;
	@Output() hideReleaseNoteChange = new EventEmitter<boolean>();

	display: boolean = true;

	constructor(public app: AppService) {}

	ngOnInit(): void {}
}
